const Footer = () => {
  const quickLinks = [
    { label: 'Services', href: '#value' },
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Target Clients', href: '#clients' },
    { label: 'Contact', href: '#contact' },
  ];

  const services = [
    'Monthly Campaigns',
    'Hourly Campaigns',
    'Event Coverage',
    'Route Planning',
    'Custom Campaigns',
  ];

  return (
    <footer className="relative overflow-hidden" style={{ backgroundColor: '#050505' }}>
      {/* Top Divider */}
      <div
        className="w-full h-px"
        style={{ background: 'linear-gradient(90deg, transparent, #00d4ff, #39ff14, #b026ff, transparent)' }}
      />

      {/* BG grid */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.03]"
        style={{
          backgroundImage: `linear-gradient(rgba(57,255,20,1) 1px, transparent 1px), linear-gradient(90deg, rgba(57,255,20,1) 1px, transparent 1px)`,
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        {/* Upper Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {/* Column 1: Brand */}
          <div>
            <img
              src="https://static.readdy.ai/image/17c770440fc9a0cd846fe980a29eae0b/c9649332f864171b785bcdb8261515ed.png"
              alt="MartLed"
              className="h-12 w-auto object-contain mb-4"
              style={{ filter: 'drop-shadow(0 0 10px rgba(0,212,255,0.5))' }}
            />
            <p className="text-gray-500 text-sm leading-relaxed mb-6 max-w-xs">
              Tampa&apos;s #1 mobile LED billboard advertising company. We drive your brand through the streets,
              delivering thousands of impressions every single day.
            </p>
            <div className="flex items-center gap-4">
              {[
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-facebook-circle-line', href: '#' },
                { icon: 'ri-tiktok-line', href: '#' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300 hover:scale-110"
                  style={{ border: '1px solid rgba(57,255,20,0.2)', color: '#6b7280' }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.color = '#39ff14';
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = '#39ff14';
                    (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 0 15px rgba(57,255,20,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.color = '#6b7280';
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(57,255,20,0.2)';
                    (e.currentTarget as HTMLAnchorElement).style.boxShadow = 'none';
                  }}
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="font-rajdhani font-bold text-base tracking-widest uppercase text-white mb-4 border-b pb-2" style={{ borderColor: 'rgba(57,255,20,0.3)' }}>
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-500 text-sm font-body transition-all duration-300 hover:text-white flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line text-xs group-hover:text-neon-green transition-colors" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Services */}
          <div>
            <h4 className="font-rajdhani font-bold text-base tracking-widest uppercase text-white mb-4 border-b pb-2" style={{ borderColor: 'rgba(0,212,255,0.3)' }}>
              Services
            </h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s}>
                  <a
                    href="#contact"
                    className="text-gray-500 text-sm font-body transition-all duration-300 hover:text-white flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line text-xs group-hover:text-neon-blue transition-colors" />
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h4 className="font-rajdhani font-bold text-base tracking-widest uppercase text-white mb-4 border-b pb-2" style={{ borderColor: 'rgba(176,38,255,0.3)' }}>
              Get in Touch
            </h4>
            <div className="space-y-4">
              <a href="tel:+18139526893" className="flex items-start gap-3 group cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg shrink-0 mt-0.5" style={{ backgroundColor: 'rgba(0,212,255,0.1)' }}>
                  <i className="ri-phone-line text-sm" style={{ color: '#00d4ff' }} />
                </div>
                <div>
                  <div className="text-xs font-rajdhani tracking-wider uppercase text-gray-600 mb-0.5">Phone</div>
                  <div className="text-gray-400 text-sm group-hover:text-white transition-colors">(813) 952-6893</div>
                </div>
              </a>
              <a href="mailto:info@martled.com" className="flex items-start gap-3 group cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg shrink-0 mt-0.5" style={{ backgroundColor: 'rgba(176,38,255,0.1)' }}>
                  <i className="ri-mail-line text-sm" style={{ color: '#b026ff' }} />
                </div>
                <div>
                  <div className="text-xs font-rajdhani tracking-wider uppercase text-gray-600 mb-0.5">Email</div>
                  <div className="text-gray-400 text-sm group-hover:text-white transition-colors">info@martled.com</div>
                </div>
              </a>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg shrink-0 mt-0.5" style={{ backgroundColor: 'rgba(57,255,20,0.1)' }}>
                  <i className="ri-map-pin-line text-sm" style={{ color: '#39ff14' }} />
                </div>
                <div>
                  <div className="text-xs font-rajdhani tracking-wider uppercase text-gray-600 mb-0.5">Location</div>
                  <div className="text-gray-400 text-sm">Tampa, Florida</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4"
          style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}
        >
          <p className="text-gray-600 text-sm">© 2025 MartLed. All rights reserved. Tampa, FL.</p>
          <p
            className="font-rajdhani font-bold text-xs tracking-widest uppercase animate-glow-pulse"
            style={{ color: '#39ff14', textShadow: '0 0 10px #39ff14' }}
          >
            THE MOST KNOWN ALWAYS BEATS THE BEST
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-600 hover:text-gray-400 text-xs transition-colors">Privacy Policy</a>
            <span className="text-gray-700">·</span>
            <a href="#" className="text-gray-600 hover:text-gray-400 text-xs transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
